import React, { Component } from "react";
import { connect } from "react-redux";
import { Card } from "components/Card/Card.jsx";
import SimpleReactValidator from "simple-react-validator";
import { FiCheck } from "react-icons/fi";
import { withRouter } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import BrandLogo from "./BrandLogo";
import Image from "react-graceful-image";

class TagLayout extends Component {
    constructor(props) {
        super(props);
        this.validatorBrand = new SimpleReactValidator();
        this.state = {
            requiredTagFlag: false,
            submitted: false
        };
    }

    pageChange = e => {
        this.props.onTagLayoutsPageChange(e.target.value);
    };

    pageChangeNavigation = val => {
        this.props.onTagLayoutsPageChange(val);
    };

    filterChange = e => {
        this.props.onTagLayoutsFilterChange(e.target.value);
    };

    selectTag = (listType, arrList, index) => {
        const nextStepNum = this.props.nextStepNum === 2 ? 3 : this.props.nextStepNum;

        if (this.props.showTagListOnly) {
            this.props.selectedTaglayoutFunction(
                listType, arrList, index
            );
        }
        else {
            this.props.selectedTaglayout(
                listType, arrList, index
            );
            setTimeout(() => {
                this.props.goToStep(nextStepNum);
            }, 1000);
        }
    }

    render() {
        const pageNumbers = [];
        for (let i = 1; i <= this.props.tagsPages; i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number} key={number} id={number}>
                    {number}
                </option>
            );
        });

        return (

            <Grid fluid>
                <Row>
                    <Col md={12}>
                        {!this.props.showTagListOnly &&
                            <div className="flexElem respFlex spaceBetween respFlex">
                                <div className="mb-lg">
                                    <div className="brandInfo flexElem respFlex alignCenter">
                                        {
                                            this.props.selectedBrand &&
                                            <BrandLogo brand={this.props.selectedBrand} customClasses="ml-md text_16" />
                                        }
                                    </div>
                                </div>
                                <div>
                                    &nbsp;
                                </div>
                            </div>
                        }
                    </Col>
                    <Col md={12}>
                        <Card
                            ctTableResponsive
                            content={
                                <div>
                                    <Grid fluid>
                                        <Row>
                                            <Col md={12}>
                                                {!this.props.showTagListOnly &&
                                                    <h3
                                                        style={{
                                                            textAlign: "center",
                                                            fontWeight: "500"
                                                        }}
                                                    >
                                                        Create Order
                                                </h3>
                                                }
                                                <form
                                                    onSubmit={
                                                        this.onBrandSubmit
                                                    }
                                                >
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="flexElem alignCenter spaceBetween">
                                                                <div>
                                                                    <h4>
                                                                        Select
                                                                        Tag
                                                                        Layout
                                                                    </h4>
                                                                </div>


                                                                <div className="searchBox">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Search Tag by Code, Title or Description"
                                                                        className="form-control"
                                                                        value={this.props.tagsFilter}
                                                                        onChange={
                                                                            this
                                                                                .filterChange
                                                                        }
                                                                    />
                                                                </div>

                                                            </div>
                                                            <div className="brandsGrid tagsGrid gridElem grid_4">
                                                                {this.props.tags.map(
                                                                    (
                                                                        tag,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                onClick={() => this.selectTag("tags", this.props.tags, index)}
                                                                                key={
                                                                                    index
                                                                                }
                                                                                className={
                                                                                    tag.isSelected
                                                                                        ? "brandInfo selectedBrand p-2"
                                                                                        : "brandInfo p-2"
                                                                                }
                                                                            >
                                                                                <div className="brandLogo" style={{backgroundColor:'white', backgroundImage: 'none'}}>
                                                                                    {tag.path && (
                                                                                        <Image
                                                                                            src={
                                                                                                process.env.REACT_APP_S3_THUMBNAIL_PATH + tag.path
                                                                                            }
                                                                                            style={{
                                                                                                maxWidth:
                                                                                                    "100%",
                                                                                                maxHeight:
                                                                                                    "300",
                                                                                                margin:
                                                                                                    "0 auto", width:'auto'
                                                                                            }}
                                                                                            alt={
                                                                                                tag.title
                                                                                            }
                                                                                            retry={{
                                                                                                count: 10,
                                                                                                delay: 2
                                                                                            }}
                                                                                            placeholderColor="#ccc"
                                                                                            // noPlaceholder={true}
                                                                                        />
                                                                                    )}
                                                                                    <span className="checked">
                                                                                        <FiCheck />
                                                                                    </span>
                                                                                </div>
                                                                                <div className="tagDetails">
                                                                                    <p>
                                                                                        Title:{" "}
                                                                                        <strong className="medium">
                                                                                            {
                                                                                                tag.title
                                                                                            }
                                                                                        </strong>
                                                                                    </p>
                                                                                    <p>
                                                                                        Code:{" "}
                                                                                        <strong className="medium">
                                                                                            {
                                                                                                tag.barcode
                                                                                            }
                                                                                        </strong>
                                                                                    </p>
                                                                                    <p>
                                                                                        {
                                                                                            tag.description
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="customPagination flexElem alignCenter spaceBetween">
                                                        <div className="flexElem alignCenter spaceBetween">
                                                            <button
                                                                type="button"
                                                                disabled={
                                                                    this.props
                                                                        .tagsCurrentPage ===
                                                                    1
                                                                }
                                                                className="paginationBtn form-control"
                                                                onClick={() =>
                                                                    this.pageChangeNavigation(
                                                                        this
                                                                            .props
                                                                            .tagsCurrentPage -
                                                                        1
                                                                    )
                                                                }
                                                            >
                                                                Previous
                                                            </button>
                                                        </div>
                                                        <div className="flexElem alignCenter spaceBetween">
                                                            Page{" "}
                                                            {
                                                                this.props
                                                                    .tagsCurrentPage
                                                            }{" "}
                                                            of{" "}
                                                            {
                                                                this.props
                                                                    .tagsPages
                                                            }
                                                        </div>
                                                        <div className="flexElem alignCenter spaceBetween">
                                                            <select
                                                                className="form-control mr-md"
                                                                onChange={
                                                                    this
                                                                        .pageChange
                                                                }
                                                            >
                                                                {
                                                                    renderPageNumbers
                                                                }
                                                            </select>
                                                            <button
                                                                disabled={
                                                                    this.props
                                                                        .tagsCurrentPage ===
                                                                    this.props
                                                                        .tagsPages
                                                                }
                                                                type="button"
                                                                className="paginationBtn form-control"
                                                                onClick={() =>
                                                                    this.pageChangeNavigation(
                                                                        this
                                                                            .props
                                                                            .tagsCurrentPage +
                                                                        1
                                                                    )
                                                                }
                                                            >
                                                                Next
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {!this.props.showTagListOnly &&
                                                        <div className="stepsNav mt-lg">
                                                            {
                                                                <div className="text-center">
                                                                    <button type="button" onClick={() =>
                                                                        this.props.goToStep(
                                                                            this.props
                                                                                .prevStepNum
                                                                        )}
                                                                        className="stepNav prev" ><MdNavigateBefore /></button>
                                                                    <span className="display_ib mt-xs">Prev</span>
                                                                </div>
                                                            }

                                                            {this.props.selectedTag != null &&
                                                                <div className="text-center">
                                                                    <button type="button" onClick={() =>
                                                                        this.props.goToStep(
                                                                            this.props.nextStepNum === 2 ? 3 : this.props.nextStepNum
                                                                        )}
                                                                        className="stepNav next"><MdNavigateNext /></button>
                                                                    <span className="display_ib mt-xs">Next</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </form>
                                            </Col>
                                        </Row>
                                    </Grid>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const { brand } = state.brandReducer;
    return {
        brand
    };
}
export default withRouter(
    connect(mapStateToProps, null)(TagLayout)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/TagLayout.jsx